import React, { useState } from "react";
import "./testiReview.css";
export const TextArea = (props) => {
  const productId = props.id;
  const [textarea, setTextarea] = useState("");
  const onChange = (e) => {
    setTextarea(e.target.value);
  };
  return (
    <div className="textAreaDiv">
      <textarea
        id={"textreview_" + productId}
        name={"textreview_" + productId}
        className=" textareaReview input "
        placeholder="Enter your Comment"
        onChange={onChange}
        value={textarea}
      />
    </div>
  );
};
export default TextArea;
